"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classNames = void 0;
/**
 * The `classNames` function allows you to dynamically create class name strings based on boolean operators
 * @param args strings or an object of class names [key] and a boolean [value] as to whether they should be used or not
 * @returns {string} the string of class names
 */
const classNames = (...args) => {
    const names = args.reduce((acc, curr) => {
        if (typeof curr === 'object') {
            return [
                ...acc,
                ...Object.entries(curr)
                    .map(([key, value]) => value ? key : undefined)
                    .filter(Boolean)
            ];
        }
        return [
            ...acc,
            curr
        ];
    }, []);
    return names.filter(Boolean).join(' ');
};
exports.classNames = classNames;
//# sourceMappingURL=classnames.js.map